export default function isValidationError(error: any) {
    return !!(error && error.inner);
}
